<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-exchange text-primary mr-2"></i>
                    Motivos de devolución
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Motivos de devolución
                    <export-actions :rows="getReasonsFilteredData()"></export-actions>
                </b-row>

                <v-client-table
                    ref="reasonsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="reasons"
                    :options="options"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                        <i
                            size="sm"
                            @click.stop="select(props.row.uuid,'reason')"
                            v-b-modal.reasons
                            class="fa fa-pencil text-primary">
                        </i>
                    </template>

                    <template slot="bank" slot-scope="props">
                        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                        {{ props.row.bank.name }}
                    </template>

                </v-client-table>

                <div class="text-right">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="hideReasons"
                        name="hide">
                        Mostrar inactivos
                    </b-form-checkbox>
                </div>

            </b-card>
        </b-row>

        <b-row class="mt-4">
            <h4 class="w-100 text-center text-primary">
                <i class="fa fa-random text-primary mr-2"></i>
                Tratamiento de devoluciones
            </h4>
        </b-row>

        <b-row class="py-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Tratamiento de devolución
                    <export-actions :rows="getActionsFilteredData()"></export-actions>
                </b-row>

                <v-client-table
                    ref="actionsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="actionColumns"
                    :data="actions"
                    :options="actionOptions"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                        <i
                            size="sm"
                            @click.stop="select(props.row.uuid,'action')"
                            v-b-modal.actions
                            class="fa fa-pencil text-primary">
                        </i>
                    </template>

                </v-client-table>

                <div class="text-right">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="hideActions"
                        name="hide">Mostrar inactivos
                    </b-form-checkbox>
                </div>

            </b-card>
        </b-row>

        <b-modal
            id="reasons"
            ref="reasons"
            title="Definir Devolucion"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok="store('reasons','reason')"
            hide-footer
            v-model="showReason">

            <b-form @submit.prevent="store('reasons','reason')">

                <b-form-group class="w-100">
                    <label for="name"><strong>Nombre *</strong></label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="name"
                            placeholder="Nombre"
                            v-model="reason.name"
                            :required="true"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group class="w-100">
                    <label for="name"><strong>Código Bancario *</strong></label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="bankCode"
                            placeholder="Código"
                            v-model="reason.bankCode"
                            :required="true"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group class="w-100">
                    <label for="bank"><strong>Banco *</strong></label>
                    <multiselect
                        name="bank"
                        v-model="reason.bankId"
                        :allow-empty="false"
                        :options="banks.map(type => type.uuid)"
                        :multiple="false"
                        :custom-label="opt => banks.find(x => x.uuid == opt).name"
                        selectLabel="+"
                        deselectLabel="-"
                        placeholder="Seleccione opción"></multiselect>
                </b-form-group>

                <div v-if="reason.uuid" class="d-inline-block float-right w-100">
                    <div class="text-right"><strong>Activo</strong></div>
                    <div class="text-right">
                        <label class="switch switch-3d switch-success">
                            <input type="checkbox" class="switch-input" v-model="reason.active" checked>
                            <span class="switch-slider"></span>
                        </label>
                    </div>
                </div>

                <b-row class="border-top pt-3 px-3">
                    <button
                        type="button"
                        @click="hideModal()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">Cerrar
                    </button>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg float-right"
                        sm="12">Guardar
                    </button>
                </b-row>

            </b-form>
        </b-modal>

        <b-modal
            id="actions"
            ref="actions"
            title="Definir Tratamiento"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok="store('actions', 'action')"
            hide-footer
            v-model="showAction">
            <b-form @submit.prevent="store('actions','action')">

                <b-form-group class="w-100">
                    <label for="name"><strong>Nombre *</strong></label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="name"
                            placeholder="Nombre"
                            v-model="action.name"
                            :required="true"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <div v-if="action.uuid" class="d-inline-block float-right w-100">
                    <div class="text-right"><strong>Activo</strong></div>
                    <div class="text-right">
                        <label class="switch switch-3d switch-success">
                            <input type="checkbox" class="switch-input" v-model="action.active" checked>
                            <span class="switch-slider"></span>
                        </label>
                    </div>
                </div>

                <b-row class="border-top pt-3 px-3">
                    <button
                        type="button"
                        @click="hideModal()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">Cerrar
                    </button>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg float-right"
                        sm="12">Guardar
                    </button>
                </b-row>

            </b-form>
        </b-modal>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {request, parseRequest} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import ExportActions from '@/components/ExportActions';

    Vue.use(ClientTable);

    export default {
        name: 'listUsers',
        components: {
            ClientTable,
            Multiselect,
            Event,
            ExportActions
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);

            this.$eventHub.$on('newReason', obj => {
                this.flush('reason');
                this.$refs.reasons.show();
            });
            this.$eventHub.$on('newAction', obj => {
                this.flush('action');
                this.$refs.actions.show();
            });
            this.options.texts = form.tableLabels();
            this.actionOptions.texts = form.tableLabels();

            this.get('refund/actions', 'get', 200, 'actions');
            this.get('refund/reasons', 'get', 200, 'reasons');
            this.get('banks', 'get', 200, 'banks');
        },
        beforeDestroy() {
            this.$eventHub.$off('newAction');
            this.$eventHub.$off('newReason');
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nuevo Motivo',
                        emit: 'newReason',
                        brand: 'fa fa-exchange',
                        permissions: ['FEE_REFUND_REASON_NEW']
                    },
                    {
                        name: 'Nuevo Tratamiento',
                        emit: 'newAction',
                        brand: 'fa fa-random',
                        permissions: ['FEE_REFUND_ACTION_NEW']
                    },
                ],
                banks: [],
                total_actions: [],
                actions: [],
                hideActions: true,
                action: {
                    name: "",
                    uuid: null,
                    active: null,
                },
                total_reasons: [],
                reasons: [],
                hideReasons: true,
                reason: {
                    name: "",
                    bankCode: "",
                    uuid: null,
                    active: null,
                },
                showReason: false,
                showAction: false,
                active: [
                    {value: true, label: 'Sí'},
                    {value: false, label: 'No'},
                ],
                columns: ['uuid', 'name', 'bank_code', 'bank'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        bank_code: 'Código Bancario',
                        bank: 'Banco',
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['name', 'bank_code', 'bank'],
                    filterable: ['name', 'bank_code', 'bank'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                actionColumns: ['uuid', 'name'],
                actionOptions: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['name'],
                    filterable: ['name'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
            }
        },
        methods: {
            async get(path, method, okCode, items) {
                try {
                    this.$_loadingMixin_showLoading();
                    this[items] = await request(path, method, okCode);
                    this['total_' + items] = this[items];
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    console.log(error)
                } finally {
                    this.$_loadingMixin_hideLoading();
                }
            },
            async store(path, items) {
                this.$_loadingMixin_showLoading();
                let response;
                try {
                    if (this[items].uuid) {
                        response = await request('refund/' + path + '/' + this[items].uuid, 'post', 200, this[items]);
                    } else {
                        response = await request('refund/' + path, 'post', 201, this[items]);
                    }
                    this[path] = await request('refund/' + path, 'get', 200);
                    this.$refs[path].hide();
                } catch (e) {
                    this.$_loadingMixin_hideLoading();
                }
                this.$_loadingMixin_hideLoading();
            },
            remove(path, item) {
                // TODO
            },
            select(uuid, item) {
                this.flush(item);

                let i = this[item + 's'].find(function (it) {
                    return it.uuid == uuid;
                });

                if (item == 'reason') {
                    this[item].bankId = form.parser(i.bank, 'uuid', 'string');
                    this[item].bankCode = i.bank_code
                }
                this[item] = Object.assign({}, this[item], i);
            },
            flush(item) {
                Object.keys(this[item]).forEach(k => this[item][k] = '');
            },
            hideModal() {
                this.$refs.reasons.hide();
                this.$refs.actions.hide();
            },
            getReasonsFilteredData() {
                if (!!this.$refs.reasonsTable) {
                    return this.$refs.reasonsTable.allFilteredData.map(reason => ({
                        'Nombre': reason.name,
                        'Código Bancario': reason.bank_code,
                        'Banco': (reason.bank !== undefined ? reason.bank.name : null)
                    }))
                } else {
                    return [];
                }
            },
            getActionsFilteredData() {
                if (!!this.$refs.actionsTable) {
                    return this.$refs.actionsTable.allFilteredData.map(reason => ({
                        'Nombre': reason.name
                    }))
                } else {
                    return [];
                }
            }
        },
        watch: {
            hideReasons() {
                if (this.hideReasons) {
                    this.reasons = this.total_reasons;
                } else {
                    this.reasons = this.total_reasons.filter(i => i.active == true);
                }
            },
            hideActions() {
                if (this.hideActions) {
                    this.actions = this.total_actions;
                } else {
                    this.actions = this.total_actions.filter(i => i.active == true);
                }
            }
        }
    }
</script>
